import { Image } from '../../components/Image'

const Separator = () => {
  return (
    <div className="separator">
      <div className="separator line">
        <span></span>
      </div>
      <Image filename="compass.png" className="separator-img" alt="Separator" />
      <div className="separator line">
        <span></span>
      </div>
    </div>
  )
}

export default Separator
